<div class="input-group">
  <app-material-date-range
    class="me-1"
    id="selectedDateRangeGregorian"
    [(dateRange)]="dateRange"
    (dateRangeChange)="selectDateRange($event)">
  </app-material-date-range>

  @if (action) {
    <div>
      <button
        data-bs-toggle="tooltip"
        title="List of PDF files"
        (click)="marketFiles()"
        mat-stroked-button
        >
        <mat-icon class="me-1">upload_file</mat-icon>
        Download
      </button>
      <button
        class="ms-1"
        mat-stroked-button
        data-bs-toggle="tooltip"
        title="List of prices"
        (click)="pricingList()">
        <mat-icon >
          list_alt
        </mat-icon>
        List
      </button>
    </div>
  }

  @if (excelExporting) {
    <button
      mat-stroked-button
      id="addButtonGroup"
      aria-expanded="false"
      (click)="excelExport()">
      <mat-icon>
        description
      </mat-icon>
      Export Excel
    </button>
  }
</div>